import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import FruitsZakatTable from "./FruitsZakatTable";
import { SERVER_URL } from "./ConstantsIslamicCalculator";
import { Fruits_Zakat_EndPoint } from "./ConstantsIslamicCalculator";
import SharedHelmet from "../Helmet";
const TITLE = "حساب زكاة الثمار - حاسبة نصاب زكاة الثمار ";
const DESCRIPTION =
  "حاسبة زكاة الثمار هي أداة تستخدم لحساب مبلغ زكاة الثمار والتمر والزروع المستحقة وفقًا للأحكام الشرعية في الإسلام. تستخدم هذه الحاسبة لحساب المبلغ المالي الذي يجب دفعه كزكاة على الثمار المحصولة.";
const KEYWORDS =
  "حساب زكاة الثمار, حاسبة زكاة التمر, زكاة الثمار, طرق حساب زكاة الثمار, مبلغ زكاة الثمار, قواعد زكاة الثمار, حساب زكاة الفواكه والخضروات, زكاة الفواكه والخضروات, زكاة الثمار في الإسلام, كيفية حساب زكاة الثمار, زكاة الثمار في الشريعة الإسلامية, حاسبة نصاب زكاة الثمار, طريقة حساب نصاب زكاة الثمار, حاسبة زكاة الثمار, نصاب زكاة الثمار في الإسلام, شروط نصاب زكاة الثمار";
const OG_URL = "https://do-calculate.com/calculator/ar/fruits-zakat/";
const apiEndpoint = `${SERVER_URL}/${Fruits_Zakat_EndPoint}`;
function FruitsZakatCalculator() {
  const [pricePerKg, setPricePerKgSilver] = useState(0);
  const [weight, setWeight] = useState(0);
  const [result, setRestul] = useState(null);
  const [error, setError] = useState(null);
  const [statusCode, setStatusCode] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [wateringMethod, setWateringMetohd] = useState("");
  const handleWeightChange = (event) => {
    setWeight(event.target.value);
  };
  const handleWateringMethodChange = (event) => {
    setWateringMetohd(event.target.value);
  };
  const handlePricePerKgChange = (event) => {
    setPricePerKgSilver(event.target.value);
  };
  const calculateFruitsZakat = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(apiEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ weight, pricePerKg, wateringMethod }),
      });
      const data = await response.json();
      setStatusCode(response.status);
      if (response.ok) {
        setRestul(data.result);
        setError(null);
      } else {
        setRestul(null);
        setError(data.error);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>احسب زكاة الثمار</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                حاسبة زكاة الثمار هي أداة تستخدم لحساب مبلغ زكاة الثمار المستحقة
                وفقًا للأحكام الشرعية في الإسلام. تستخدم هذه الحاسبة لحساب
                المبلغ المالي الذي يجب دفعه كزكاة على الثمار المحصولة، وهي تشمل
                جميع أنواع الثمار. بالإضافة إلى ذلك، يمكن أيضًا استخدام حاسبة
                زكاة التمر لحساب مبلغ زكاة التمر المستحقة بناءً على الكمية
                والقيمة المالية للتمر المحصول. يمكنك استخدام هذه الأدوات لضمان
                أداء زكاتك بشكل صحيح ووفقًا للتعاليم الدينية.
                <br />
                <hr />
              </div>
              <br />
            </div>
            <div className="row">
              <div className="col-12 col-md-5 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  زكاة الثمار
                </div>
                <hr />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="weightNumber" className="form-label ms-2">
                      إجمالي وزن الثمار والزروع{" "}
                    </label>
                  </b>
                  <input
                    type="number"
                    id="weightNumber"
                    value={weight}
                    onChange={handleWeightChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                  />
                  <div className="input-group-append">
                    <span className="input-group-text">كغ</span>
                  </div>
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label
                      htmlFor="pricePerKgNumber"
                      className="form-label ms-2"
                    >
                      سعر الكيلو الغرام الواحد{" "}
                    </label>
                  </b>
                  <input
                    type="number"
                    id="pricePerKgNumber"
                    value={pricePerKg}
                    onChange={handlePricePerKgChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                  />
                </div>
                <br />
                <div>
                  <b>
                    <label htmlFor="method" className="form-label ms-2">
                      طريقة الري المستخدمة
                    </label>
                  </b>
                  <select
                    id="method"
                    className="form-select"
                    value={wateringMethod}
                    onChange={handleWateringMethodChange}
                  >
                    <option value="">-- إختر النشاط --</option>
                    <option value="no-cost">بدون تكلفة</option>
                    <option value="mid-cost">تكلفة متوسطة</option>
                    <option value="full-cost">تكلفة كاملة</option>
                  </select>
                </div>
                <br />
                <hr />
                <button
                  className="btn btn-success"
                  style={{ fontSize: "20px" }}
                  onClick={calculateFruitsZakat}
                       >
                    احسب
                    </button>              </div>
              <div className="col-12 col-md-7">
                <br />
                {statusCode === 400 && (
                  <div className="alert alert-warning">
                    <b>
                      <u> حدث خطأ :</u>
                    </b>{" "}
                    يُرجى إدخال جميع الحقول بالشكل الصحيح.{" "}
                  </div>
                )}
                {result && (
                  <div>
                    <h4>
                      <div className="p-3 mb-2 bg-success text-white">
                        النتائج:{" "}
                      </div>
                    </h4>
                    <hr />
                    <FruitsZakatTable result={result}></FruitsZakatTable>
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                وصف حاسبة زكاة الثمار والزروع{" "}
              </div>
              <div className="info-section-body">
                <u>
                  <b> حاسبة زكاة الثمار </b>{" "}
                </u>{" "}
                <br/>                تأخذ الحاسبة ثلاثة معاملات:
                <ul>
                  <li>وزن الثمار (بالكيلوغرام)</li>
                  <li>سعر الكيلوغرام الواحد من الثمار</li>
                  <li>طريقة الري</li>
                </ul>
                تقوم الحاسبة بحساب زكاة الثمار بناءً على العوامل التالية:
                <ul>
                  <li>إذا كانت طريقة الري بدون تكلفة، فنسبة الزكاة تكون 10٪</li>
                  <li>
                    إذا كانت طريقة الري بتكلفة كاملة، فنسبة الزكاة تكون 5٪
                  </li>
                  <li>
                    إذا كانت طريقة الري بتكلفة متوسطة، فنسبة الزكاة تكون 7.5٪
                  </li>
                </ul>
                ثم يتم حساب قيمة زكاة الثمار في الكيلوغرامات والقيمة المالية
                بناءً على الوزن ونسبة الزكاة وسعر الكيلوغرام الواحد من الثمار.
                ويتم تحديد الحد الأدنى لزكاة الثمار بقيمة 635 كيلوغرام.
                <br/>                تُعيد الحاسبة النتيجة في كائن يحتوي على المعلومات التالية:
                <ul>
                  <li>قيمة زكاة الثمار بالكيلوغرامات.</li>
                  <li>قيمة زكاة الثمار المالية.</li>
                  <li>الحد الأدنى لزكاة الثمار.</li>
                </ul>
                <br />
                <hr />
                <b>المصدر: </b>
                <a href="https://www.islamweb.net/ar/fatwa/119852/%D8%B2%D9%83%D8%A7%D8%A9%D9%8F-%D8%A7%D9%84%D8%B2%D9%91%D9%8E%D8%B1%D9%92%D8%B9%D9%90-%D8%A7%D9%84%D9%88%D9%8E%D8%A7%D8%AD%D9%90%D8%AF%D9%90-%D8%A5%D8%B0%D8%A7-%D8%A7%D8%AC%D8%AA%D9%8E%D9%85%D9%8E%D8%B9-%D9%81%D9%90%D9%8A%D9%87-%D8%A7%D9%84%D8%B3%D9%91%D9%8E%D9%82%D9%92%D9%8A%D9%8F-%D8%A8%D9%90%D9%85%D9%8E%D8%A7%D8%A1%D9%90-%D8%A7%D9%84%D8%B3%D9%91%D9%8E%D9%85%D9%8E%D8%A7%D8%A1%D9%90-%D9%88%D8%A7%D9%84%D8%A2%D9%84%D9%8E%D8%A9#:~:text=%D9%83%D9%85%D8%A7%20%D8%A3%D9%86%20%D8%A7%D9%84%D8%AC%D9%8F%D9%84%D8%A8%D8%A7%D9%86%20%D8%AA%D8%AC%D8%A8%D9%8F%20%D9%81%D9%8A%D9%87,%D9%88%D9%82%D9%8A%D9%84%D9%8E%20%D8%A8%D9%84%20%D9%8A%D9%8F%D8%B9%D8%AA%D8%A8%D8%B1%D9%8F%20%D8%A8%D8%A7%D9%84%D8%A3%D8%BA%D9%84%D8%A8%20%D9%85%D9%86%D9%87%D9%85%D8%A7">
                  إسلام ويب
                </a>{" "}
                <br />
                <b>تاريخ اخر مراجعة : </b>
                28/02/2026
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default FruitsZakatCalculator;
